export type DiscountCalculation = {
  originalPrice: number;
  discountedPrice: number;
  discountAmount: number;
  discountPercentage: number;
};

export class DiscountService {
  constructor(private readonly originalPrice: number) {}

  fromDiscountedPrice(discountedPrice: number): DiscountCalculation {
    if (discountedPrice < 0 || discountedPrice > this.originalPrice)
      return {
        originalPrice: this.originalPrice,
        discountedPrice: discountedPrice,
        discountAmount: 0,
        discountPercentage: 0,
      };

    const discountAmount = this.originalPrice - discountedPrice;
    const discountPercentage = (discountAmount / this.originalPrice) * 100;

    return {
      originalPrice: this.originalPrice,
      discountedPrice: discountedPrice,
      discountAmount: discountAmount,
      discountPercentage: discountPercentage,
    };
  }

  fromDiscountAmount(discountAmount: number): DiscountCalculation {
    if (discountAmount <= 0 || discountAmount > this.originalPrice)
      return {
        originalPrice: this.originalPrice,
        discountedPrice: this.originalPrice,
        discountAmount,
        discountPercentage: 0,
      };

    const discountedPrice = this.originalPrice - discountAmount;
    const discountPercentage = (discountAmount / this.originalPrice) * 100;

    return {
      originalPrice: this.originalPrice,
      discountedPrice: discountedPrice,
      discountAmount: discountAmount,
      discountPercentage: discountPercentage,
    };
  }

  fromDiscountPercentage(discountPercentage: number): DiscountCalculation {
    if (discountPercentage <= 0 || discountPercentage > 100)
      return {
        originalPrice: this.originalPrice,
        discountedPrice: this.originalPrice,
        discountAmount: 0,
        discountPercentage,
      };

    const discountedPrice = this.originalPrice * (1 - discountPercentage / 100);
    const discountAmount = this.originalPrice - discountedPrice;

    return {
      originalPrice: this.originalPrice,
      discountedPrice: discountedPrice,
      discountAmount: discountAmount,
      discountPercentage: discountPercentage,
    };
  }
}
